module.exports = __webpack_public_path__ + "static/media/gallery_dragon_argent.68570b29.png";